import styled from 'styled-components'
import { colors, measurments } from '../utils/config'

const StyledSelect = styled.div<{ $hasNoMargin?: boolean }>`
  label,
  span,
  select {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
  select {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${colors.gray500};
    border-radius: ${measurments.borderRadius}px;
    font-size: 0.875rem;
    color: ${colors.gray700};
    padding: 0.6rem;
  }
  margin-bottom: ${({ $hasNoMargin }) => ($hasNoMargin ? '0' : '1.6rem')};
  &.light {
    label {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      color: ${colors.gray700};
    }
    span {
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 400;
      color: ${colors.gray600};
      margin-bottom: 0.25rem;
    }
    select {
      font-size: 0.875rem;
      padding: 0.4rem;
    }
  }
`

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  noMargin?: boolean
  desc?: string
  label?: string
  light?: boolean
}

const Select = (props: Props) => {
  const { noMargin, desc, label, light, className, ...selectProps } = props
  return (
    <StyledSelect
      $hasNoMargin={noMargin}
      className={`${light ? 'light' : ''} ${className}`}
    >
      {label && <label htmlFor={props.id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <select {...selectProps}>{props.children}</select>
    </StyledSelect>
  )
}

export default Select
